import axios from "@/utils/axios";

export const goProject = (data) => {
  return axios.post({
    url: "/goProject",
    data,
  });
};

// 申请演示
export const applyUse = (data) => {
  return axios.post({
    url: "/v1/trial-apply",
    data,
  });
};
